/**
 * Created by timzhang on 2017/4/18.
 */
import axios from "axios";
import URLSearchParams from './UrlSearchParams';
import { createHashHistory } from "history";
import {message} from "antd";
import {push} from 'connected-react-router';
if (process.env.NODE_ENV !== 'production') {
    axios.defaults.baseURL = domain;
}
const history = createHashHistory();
export const domain = process.env.NODE_ENV === 'development' ? 'https://t.loviact.com' : 'https://t.loviact.com';
export const domainAdmin = process.env.NODE_ENV === 'development' ? 'https://t.loviact.com' : "https://t.loviact.com";
// export const domain = process.env.NODE_ENV === 'production' ? 'http://assessment.iwedoing.com' : 'http://wd-user.exuetech.com';
// export const domainAdmin = process.env.NODE_ENV === 'production' ? 'http://yxtest.iwedoing.com' : "http://wd-admin.exuetech.com";


let store = null;

export function setStore(s) {
    store = s;
    console.log(s);
}

export function historyPush(path,state) {
    history.push({pathname:path,state})
}

export function clearStore() {
    store && store.dispatch({type: 'RESET'});
    sessionStorage.clear();
}

function trimStr(str) {
    return str.replace(/(^\s*)|(\s*$)/g, "");
}


export function getCookie(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = trimStr(cookies[i]);
            // Does this cookie string begin with the name we want?
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}

const noCodeAxios = axios.create();

axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.put['Content-Type'] = 'application/json';
// if (process.env.NODE_ENV !== 'production') {
//     axios.defaults.baseURL = domain;
// }

axios.interceptors.request.use(function (config) {
    // Do something before request is sent
    const csrfToken = getCookie('csrftoken');
    if (csrfToken) config.headers['X-CSRFToken'] = csrfToken;
    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
})
axios.interceptors.response.use(function (response) {
    message.destroy();
    // Do something with response data
    log("Axios response", response);
    if (response.data.code === 0) {
        return response.data;
    } else if (response.data.code === 40401) {
        store.dispatch(push('/login'));
        clearStore();
        return Promise.reject(response.data);
    }else if(response.data.code === 44014){
        const {messages} = store.getState().lang;
        message.error(messages[`code${response.data.code}`]);
        setTimeout(()=>{
            store.dispatch(push('/question/part'));
        },2000)
        return
    }

    if (store) {
        const {messages} = store.getState().lang;
        message.error(messages[`code${response.data.code}`]);
    }
    return Promise.reject(response.data);
}, function (error) {
    message.destroy();
    log("Axios error", error);
    return Promise.reject(error);
});

/**
 * 打印调试信息,使用时和console.log一致.production版不会打印任何东西
 */
export function log(text) {
    if (process.env.NODE_ENV !== 'production') {
        console.log(...arguments);
    }
}

/**
 * 使用axios进行网络请求
 * @param url 请求的URL
 * @param method 请求方式，小写
 * @param params URL参数
 * @param data post等请求的body
 * @returns {AxiosPromise}
 */
export function request(url, method = 'get', params = {}, data = {}) {
    return axios({
        method: method,
        url: `${domain}${url}?timesteamp=${+new Date}`,
        params: params,
        data: data,
    });
}

export function request2(url, method = 'get', data = {}) {
    return axios({
        method: method,
        url: `${url}?timesteamp=${+new Date}`,
        data: data,
    });
}

export function submit(url,method = 'post', data = {},successCallback) {
    axios.defaults.headers.post['Content-Type'] = "application/x-www-form-urlencoded";
    return axios({
        method: method,
        url: `${url}?timesteamp=${+new Date}`,
        data: data,
    }).then(res => {successCallback(res);})
}


export function requestPost(url,method = 'post', data = {}) {
    return axios({
        method: method,
        url: `${domain}${url}?timesteamp=${+new Date}`,
        data: data,
    });
}


export function requestAdmin(url, method = 'get', params = {}, data = {}) {
    return axios({
        method: method,
        url: `${domainAdmin}${url}?timesteamp=${+new Date}`,
        params: params,
        data: data,
    });
}
noCodeAxios.defaults.withCredentials=true;
export function requestAdminFormData(url, method = 'POST', data = {}) {

    return noCodeAxios({
        method: method,
        url: `${url}`,
        data:data,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}

noCodeAxios.interceptors.response.use(function (response) {
    console.log(response,'返回');
    return response
}, function (error) {
    log("Axios error", error);
    return Promise.reject(error);
});

noCodeAxios.interceptors.request.use(function (config) {
    // Do something before request is sent
    console.log(config,'请求前')
    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
})

/**
 * 获取URL参数
 * @param name 参数名称
 * @param search search字段 不传 默认是window.location.search
 * @returns 查询到的值 或 null
 */
export function getQueryString(name, search = window.location.search) {
    const params = new URLSearchParams(search);
    return params.get(name);
    // let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    // let r = window.location.search.substr(1).match(reg);
    // if (r !== null) return decodeURIComponent(r[2]);
    // return null;
}

/**
 * 新标签页打开页面
 * @param url
 */
export function openURL(url) {
    const el = document.createElement("a");
    el.href = url; //url 是你得到的连接
    el.target = '_blank'; //指定在新窗口打开
    el.click();
}

const emailRex = /[\w!#$%&'*+\/=?^_`{|}~-]+(?:\.[\w!#$%&'*+\/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/;
const phoneReg = /(^1[3|4|5|7|8]\d{9}$)|(^09\d{8}$)/;

/**
 * 是否是邮箱地址
 * @param emailStr
 * @returns {boolean}
 */
export function isEmail(emailStr) {
    return emailRex.test(emailStr);
}

/**
 * 是否是手机号
 * @param phoneStr
 * @returns {boolean}
 */
export function isPhone(phoneStr) {
    return phoneReg.test(phoneStr);
}

/**
 * 验证账号
 * @param accountStr 账号
 * @param type 账号类型 phone email
 * @returns {boolean} 验证是否通过
 */
export function validAccount(accountStr, type) {
    if (type === 'email') {
        return isEmail(accountStr);
    } else if (type === 'phone') {
        return isPhone(accountStr);
    } else {
        return false;
    }
}

/**
 * 秒转时间字符串 如 7200 -> 02:00:00
 * @param s
 * @returns {*}
 */
export const secToTime = (s) => {
    let t;
    if (s > -1) {
        let hour = Math.floor(s / 3600);
        let min = Math.floor(s / 60) % 60;
        let sec = s % 60;
        if (hour < 10) {
            t = '0' + hour + ":";
        } else {
            t = hour + ":";
        }

        if (min < 10) {
            t += "0";
        }
        t += min + ":";
        if (sec < 10) {
            t += "0";
        }
        t += sec;
    }
    return t;
};

export function throttle(func, wait = 500) {
    // 利用闭包保存定时器和上次执行时间
    let timer = null;
    let previous; // 上次执行时间
    return function () {
        // 保存函数调用时的上下文和参数，传递给 fn
        const context = this;
        const args = arguments;
        const now = +new Date();
        if (previous && now < previous + wait) { // 周期之中
            clearTimeout(timer);
            timer = setTimeout(function () {
                previous = now;
                func.apply(context, args);
            }, wait);
        } else {
            previous = now;
            func.apply(context, args);
        }
    }.bind(this);
}

/**
 * 获取多语言值
 * @param obj
 * @param key
 * @returns {*}
 */
export function getValueByLang(obj, key) {
    const lang = store.getState().lang.lang;
    if (lang.toLowerCase() === 'zh') {
        return obj[key];
    } else {
        return obj[`en_${key}`] ? obj[`en_${key}`] : obj[key];
    }
}